import { render } from "./ProductAdvertisingPage.vue?vue&type=template&id=24010a8a"
import script from "./ProductAdvertisingPage.vue?vue&type=script&lang=js"
export * from "./ProductAdvertisingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__